<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">申购</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>普通申购</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <base-setting @refresh="getProjectList"></base-setting>
        <div>
          允许用户查看的快照天数：{{ seeDay }}
          <i class="el-icon-edit" @click="setDay" />
        </div>
        <!-- <setrules></setrules> -->
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import Setrules from './components/setrules';
import BaseSetting from './components/baseSetting';

export default {
  name: 'purchaseProject',
  data() {
    return {
      seeDay: 0
    };
  },
  components: {
    List,
    Create,
    Setrules,
    BaseSetting
  },
  computed: {
    ...mapState('purchaseProject', ['pagination'])
  },
  methods: {
    ...mapActions('purchaseProject', [
      'getList',
      'getCoinTypeList',
      'getRelativePrice',
      'getDayOfAmount',
      'setDayOfAmount',
      'getaward'
    ]),
    getProjectList(data = {}) {
      this.getList({
        type: 0,
        ...this.pagination,
        ...data
      });
    },
    setDay() {
      this.$prompt('设置用户可看的余额快照天数', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '天数' : true;
        }
      }).then(({ value }) => {
        this.setDayOfAmount({ day: Number(value) }).then(() => {
          this.$message.success('操作成功！');
          this.getDayOfAmount().then(res => {
            this.seeDay = res.data;
          });
        });
      });
    }
  },
  created() {
    this.getProjectList({ type: 0 });
    this.getCoinTypeList();
    this.getDayOfAmount().then(res => {
      this.seeDay = res.data;
    });
    // this.getRelativePrice();
  }
};
</script>
